<div class="row">
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Name</label>
      <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name"/>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group input-group-sm">
      <label>Period</label>
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Refresh (Seconds)</label>
      <input min="60" type="text" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval"/>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Widget Size</label>
      <select [(ngModel)]="w.size" class="form-select">
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-3">

  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
    </div>
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="w.showCategories" disabled/> Show Categories
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showLegend" /> Show Legend
    </div>
  </div>
</div>
<br/>
<br/>

<div class="row" *ngIf="w && w.timeSeriesDetailList">
  <div class="col-lg-12">
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group input-group-sm">
          <label>Select Time Series</label>
          <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="w.timeSeriesDetailList[0]" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
          <!--<app-time-series-select [timeSeriesDetail]="w.timeSeriesDetailList[0]" [enableTagMatch]="true"></app-time-series-select>-->
        </div>
        <!-- <div class="form-group input-group-sm">
          <label>Display Name</label>
          <input type="text" size="20" [(ngModel)]="w.timeSeriesDetailList[0].name" class="form-control">
        </div>
        <div class="form-group input-group-sm">
          <label>Value Suffix</label>
          <input type="text" [(ngModel)]="w.timeSeriesDetailList[0].valueSuffix" class="input-group form-control"/>
        </div> -->
        <div class="col-lg-12" *ngIf="w.showCategories">
          <div class="form-group input-group-sm">
            <label>Display Value</label>
            <select [(ngModel)]="w.timeSeriesDetailList[0].displayValue" class="group-select m-b form-select">
              <option value="min">Min</option>
              <option value="max">Max</option>
              <option value="average">Average</option>
              <option value="count">Count</option>
              <option value="sum">Sum</option>
              <option value="sumPercentage">Sum Percentage</option>
              <option value="countPercentage">Count Percentage</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <app-transform-editor [transforms]="w.timeSeriesDetailList[0].transforms"></app-transform-editor>
        </div>
      </div>
    </div>  
  </div>
</div>  
  
